import styled from 'styled-components';

export const Root = styled.ul`
  position: absolute;
  background: #415667 !important;
  color: #fff !important;
  border-radius: 0.6em;
  z-index: 99;
  right: -25%;
  bottom: 36px;
  margin-top: 5px;
  width: auto;
  min-width: 184px;
  overflow: hidden;
`;

export const ListItem = styled.li(props => `
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 28px;
    cursor: pointer;
    padding: 8px;
    border-bottom: 1px solid #999b9d;
    ${props.disabled && (
    `
        pointer-events: none;
        opacity: 0.6;
      `
  )}
    
    svg {
    width: 22px !important;
    height: 22px !important;
    }
    
    div[class*="svgIconComponent---"] {
    width: 22px !important;
    height: 22px !important;
    }
    
    &:last-child {
    border: none;
    }
    
    &:hover {
    background-color: #c3d5e1 !important;
    color: #415667 !important;
    
      * {
      fill: #415667 !important;
      }
    }
    `);

export const ItemText = styled.span(props => `
    margin-left: ${props.large ? '14px' : '0'}
    font-size: ${props.large ? '14px' : '12px'};
  `);



// WEBPACK FOOTER //
// ./components/footer/footer-popup/styled.js